import { BIZ_TARGET_TYPE, BizTargetType } from '@/constants/bizTargetType';

export const getCompanyName = (partnerName = '', dealerName = '') => {
  return partnerName || dealerName;
};

export const getSubCompanyName = (bizTargetType: BizTargetType, dealerName = '') => {
  if (bizTargetType === BizTargetType.INDIRECT_PARTNER) {
    return dealerName;
  }

  if (bizTargetType === BizTargetType.DEALER) {
    return `${BIZ_TARGET_TYPE[BizTargetType.DEALER]}`;
  }

  return BIZ_TARGET_TYPE[BizTargetType.DIRECT_PARTNER];
};

/** 해당 사업자에 딜러사명을 정하는 함수 */
export const getDealerName = (bizTargetType: BizTargetType, dealerName = '') => {
  if (bizTargetType === BizTargetType.DEALER) {
    return '딜러사';
  }

  if (bizTargetType === BizTargetType.INDIRECT_PARTNER) {
    return dealerName;
  }

  return '';
};
